const Details = function () {

  function init() {
    const elements = document.querySelectorAll('details')

    elements.forEach(element => {
      element.addEventListener('hide', pauseMediaTarget)
      element.addEventListener('toggle', event => {
        if (!event.target.open) {
          pauseMediaTarget(event)
        } else {
          const name = element.getAttribute('name')
          const detailsElements = document.querySelectorAll(`details[name="${name}"][open]`)

          detailsElements.forEach(details => {
            if (details !== element) {
              details.removeAttribute('open')
            }
          });
        }

      })
    })
  }

  function pauseMediaTarget(event) {
    const mediaElements = event.target.querySelectorAll('audio, video')
    if (mediaElements.length) {
      mediaElements.forEach(element => element.pause())
    }
  }

	return {
		init,
	}
}()

export default Details
